import { isObject } from "./index";

/**
 * Rules
 * {
 *     a: { blank: false },
 *     g: {
 *       z: { blank: false }
 *     }
 *   }
 */
const prepareValues = (data: any, rules?: any) => {
  const obj: any = {...data};

  for (const [key, value] of Object.entries(obj)) {
    let preparedValue = value;
    const rule = rules ? rules[key] : undefined;

    if (isObject(value)) {
      preparedValue = prepareValues(value, rule);
      obj[key] = preparedValue;
    } else if(typeof value === 'undefined' || value === null) {
      if (rule?.blank === false) {
        delete obj[key];
      } else {
        obj[key] = '';
      }
    }
  }

  return obj;
}

const buildFormData = (formData: any, data: any, parentKey?: string) => {
  if (isObject(data)) {
    for (const [key, value] of Object.entries(data)) {
      buildFormData(formData, value, parentKey ? `${parentKey}[${key}]` : key)
    }
  } else if (Array.isArray(data)) {
    data.forEach(arrValue => {
      buildFormData(formData, arrValue, `${parentKey}[]`);
    });
  }
  else {
    formData.append(parentKey, data);
  }
}

export const filterOption = (input: string, option: any) => {
  return (option!.children as unknown as string).toLowerCase().includes(input.toLowerCase());
}

export const filterOptionByLabel = (input: string, option: any) => {
  return (option!.label as unknown as string).toLowerCase().includes(input.toLowerCase());
}

export const getBase64 = (file: any): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });

export const objToFormData = (data: any, rules?: any) => {
  const prepared = prepareValues(data, rules);
  const formData = new FormData();

  buildFormData(formData, prepared);

  return formData;
}
